var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-perfil"},[_c('div',[_c('Navbar',{attrs:{"values":_vm.article}})],1),_c('MainNominados',{attrs:{"nominado":_vm.nominado}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }